import React, { useEffect, useState } from 'react';
import { X, Check, ShieldCheck, Lock } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { PriceDisplay } from './PriceDisplay';
import { usePricingContext } from '../context/PricingContext';
const carouselImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/ayZcGZTq5rLZchFZtwqF2C/4.webp',
  alt: 'Carta de Pablo a los Romanos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r92wnwRK3s4TiEkt4KGWmu/6.webp',
  alt: 'Primera Carta de Pablo a los Corintios'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3YrttGqjEWV7NWoNPxcxhh/8.webp',
  alt: 'Segunda Carta de Pablo a los Corintios'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hVKEmnSq7r9mWqpeXprq5m/10.webp',
  alt: 'Carta de Pablo a los Gálatas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9pp911A89HiVpR4SpXDGce/12.webp',
  alt: 'Carta de Pablo a los Efesios'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s9FGpEyz4anEfQAnW9CrYF/14.webp',
  alt: 'Carta de Pablo a los Filipenses'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dg1ycQweQDzmk2N1Vtrauh/16.webp',
  alt: 'Carta de Pablo a los Colosenses'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5YxKrsLoGoYfgqLuKu3zgN/18.webp',
  alt: 'Primera Carta de Pablo a los Tesalonicenses'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3gMDHN6r5958sMKBEv2Hvq/20.webp',
  alt: 'Segunda Carta de Pablo a los Tesalonicenses'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eqJLg3iLAgCg4dmE2tL5R6/22.webp',
  alt: 'Primera Carta de Pablo a Timoteo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/t834o4XLVRU4ydmLasjL6p/24.webp',
  alt: 'Segunda Carta de Pablo a Timoteo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9FaGrcfxTz7JMgnwMgnKFP/26.webp',
  alt: 'Carta de Pablo a Tito'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qyb33J78vsZxUS5cWrH8Lp/28.webp',
  alt: 'Carta de Pablo a Filemón'
}];
function ProductCarousel() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent(prev => (prev + 1) % carouselImages.length);
        setAnimating(false);
      }, 350);
    }, 2800);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative w-full max-w-xs mx-auto" data-id="element-158">
      <div className="relative rounded-2xl overflow-hidden" style={{
      boxShadow: '0 12px 48px rgba(60,40,10,0.18), 0 2px 8px rgba(60,40,10,0.08)',
      border: '2px solid rgba(200,169,106,0.35)',
      aspectRatio: '3/4'
    }} data-id="element-159">
        <img src={carouselImages[current].src} alt={carouselImages[current].alt} className="w-full h-full object-cover" style={{
        opacity: animating ? 0 : 1,
        transition: 'opacity 0.35s ease'
      }} data-id="element-160" />
        <div className="absolute bottom-0 left-0 right-0 h-12 pointer-events-none" style={{
        background: 'linear-gradient(to top, rgba(200,169,106,0.15), transparent)'
      }} data-id="element-161" />
      </div>
      <div className="flex justify-center gap-1.5 mt-3" data-id="element-162">
        {carouselImages.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className="rounded-full transition-all duration-300" style={{
        width: i === current ? '20px' : '6px',
        height: '6px',
        background: i === current ? '#C8A96A' : 'rgba(200,169,106,0.3)'
      }} data-id="element-163" />)}
      </div>
      <p className="text-center text-xs mt-1.5 font-bold tracking-widest uppercase" style={{
      color: '#9A9A9A'
    }} data-id="element-164">
        {current + 1} / {carouselImages.length}
      </p>
    </div>;
}
export function SalesLetter() {
  const {
    cartLink,
    fireAddToCart
  } = usePricingContext();
  // Formatted pain points — same words, added visual emphasis
  const painPointsFormatted = [<>
      Abres la Biblia en{' '}
      <strong style={{
      color: '#1C1C1C'
    }} data-id="element-165">
        Romanos o Efesios
      </strong>{' '}
      y sientes que lees... pero{' '}
      <strong style={{
      color: '#8B2020'
    }} data-id="element-166">
        NO entiendes
      </strong>{' '}
      lo que Pablo realmente quiso decir.
    </>, <>
      Intentaste leer comentarios bíblicos <em data-id="element-167">"académicos"</em> y terminaste{' '}
      <strong style={{
      color: '#8B2020'
    }} data-id="element-168">
        MÁS confundido
      </strong>{' '}
      — <em data-id="element-169">ahogado en tecnicismos que nadie entiende.</em>
    </>, <>
      Necesitas preparar sermones o estudios bíblicos profundos pero no
      encuentras material que sea{' '}
      <strong style={{
      color: '#1C1C1C'
    }} data-id="element-170">
        claro Y completo
      </strong>{' '}
      a la vez.
    </>, <>
      No logras conectar las enseñanzas de hace 2,000 años con tu{' '}
      <strong style={{
      color: '#1C1C1C'
    }} data-id="element-171">
        vida diaria, tu familia
      </strong>{' '}
      y tus problemas de{' '}
      <strong style={{
      color: '#8B2020',
      textDecoration: 'underline',
      textDecorationColor: 'rgba(139,32,32,0.4)',
      textDecorationThickness: '1.5px',
      textUnderlineOffset: '3px'
    }} data-id="element-172">
        HOY
      </strong>
      .
    </>, <>
      Tienes dudas bíblicas que{' '}
      <em style={{
      color: '#505050'
    }} data-id="element-173">
        te avergüenza preguntar
      </em>{' '}
      porque <em data-id="element-174">"se supone"</em> que ya deberías saber la respuesta.
    </>];
  return <section className="py-8 md:py-14 relative pt-[10px] pb-[10px]" style={{
    background: '#FBF8F2'
  }} data-id="element-175">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-176">
        {/* Pain Section */}
        <div className="rounded-2xl p-5 md:p-10 mb-8" style={{
        background: '#F6F1E7',
        border: '1px solid rgba(200,169,106,0.3)',
        boxShadow: '0 2px 20px rgba(60,40,10,0.07)'
      }} data-id="element-177">
          <h2 className="md:text-3xl font-serif font-bold text-center mb-6 text-[22px]" style={{
          color: '#161616'
        }} data-id="element-178">
            Este Material Es Para Ti Si...
          </h2>
          <ul className="space-y-4" data-id="element-179">
            {painPointsFormatted.map((point, index) => <li key={index} className="flex items-start" data-id="element-180">
                <div className="flex-shrink-0 mt-1" data-id="element-181">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center" style={{
                background: 'rgba(139,32,32,0.10)',
                border: '1px solid rgba(139,32,32,0.3)'
              }} data-id="element-182">
                    <X className="w-3 h-3" style={{
                  color: '#8B2020'
                }} data-id="element-183" />
                  </div>
                </div>
                <p className="ml-3 text-base leading-relaxed" style={{
              color: '#2C2C2C'
            }} data-id="element-184">
                  {point}
                </p>
              </li>)}
          </ul>
        </div>

        {/* Agitation */}
        <div className="text-center mb-8 space-y-4" data-id="element-185">
          <p className="text-lg leading-relaxed" style={{
          color: '#2C2C2C'
        }} data-id="element-186">
            Estos son exactamente los desafíos que enfrentan{' '}
            <strong data-id="element-187">miles de cristianos</strong> que desean{' '}
            <span style={{
            textDecoration: 'underline',
            textDecorationColor: '#C8A96A',
            textDecorationThickness: '1.5px',
            textUnderlineOffset: '3px'
          }} data-id="element-188">
              comprender la Palabra de Dios con mayor profundidad
            </span>
            …
          </p>
          <p className="italic text-[16px]" style={{
          color: '#505050'
        }} data-id="element-189">
            y también los mismos obstáculos que nuestros estudiantes nos
            compartían una y otra vez.
          </p>
          <div className="py-4 px-5 rounded-xl" style={{
          background: 'rgba(200,169,106,0.10)',
          border: '1px solid rgba(200,169,106,0.25)'
        }} data-id="element-190">
            <p className="text-lg font-serif font-bold" style={{
            color: '#161616'
          }} data-id="element-191">
              Porque la verdad es simple:{' '}
              <span style={{
              textDecoration: 'underline',
              textDecorationColor: '#C8A96A',
              textDecorationThickness: '2px',
              textUnderlineOffset: '4px'
            }} data-id="element-192">
                Entender la Biblia NO debería sentirse confuso, técnico ni
                abrumador.
              </span>
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="relative py-5 text-center pt-[0px] pb-[0px] mb-[0px]" data-id="element-193">
          <div className="gold-divider absolute inset-x-0 top-1/2" data-id="element-194" />
          <div className="relative flex justify-center" data-id="element-195">
            <span className="px-5 text-sm font-bold tracking-wide font-serif" style={{
            background: '#FBF8F2',
            color: '#B89555'
          }} data-id="element-196">
              Por eso decidimos crear una forma distinta…
            </span>
          </div>
        </div>

        {/* Solution Setup */}
        <div className="space-y-4 text-base leading-relaxed mb-8" style={{
        color: '#2C2C2C'
      }} data-id="element-197">
          <p data-id="element-198">
            Una manera{' '}
            <strong data-id="element-199">clara, guiada y profundamente comprensible</strong> de
            estudiar las enseñanzas del Apóstol Pablo —{' '}
            <span style={{
            textDecoration: 'underline',
            textDecorationColor: '#C8A96A',
            textDecorationThickness: '1.5px',
            textUnderlineOffset: '3px'
          }} data-id="element-200">
              paso a paso, versículo por versículo.
            </span>
          </p>
          <p className="italic" style={{
          color: '#505050'
        }} data-id="element-201">
            Si anhelas abrir tu Biblia y{' '}
            <strong style={{
            color: '#161616',
            fontStyle: 'normal'
          }} data-id="element-202">
              entender realmente lo que estás leyendo…
            </strong>
          </p>
          <div className="p-5 rounded-xl" style={{
          background: 'rgba(200,169,106,0.08)',
          borderLeft: '3px solid #C8A96A'
        }} data-id="element-203">
            <p className="text-lg font-serif italic" style={{
            color: '#2C2C2C'
          }} data-id="element-204">
              entonces lo que estás a punto de descubrir puede{' '}
              <strong style={{
              fontStyle: 'normal'
            }} data-id="element-205">
                transformar completamente
              </strong>{' '}
              tu forma de estudiar la Palabra.
            </p>
          </div>
        </div>

        {/* ─── THE REVEAL ─── */}
        <div className="text-center mb-8" data-id="element-206">
          <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
          color: '#B89555'
        }} data-id="element-207">
            Presentamos...
          </p>

          <div className="headline-glow mb-6" data-id="element-208">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-2 leading-tight" style={{
            color: '#161616'
          }} data-id="element-209">
              LAS CARTAS DE PABLO
            </h2>
            <h3 className="md:text-2xl font-serif mb-0 text-gold-gradient text-[16px]" data-id="element-210">
              EXPLICADAS VERSÍCULO POR VERSÍCULO
            </h3>
          </div>

          <ProductCarousel data-id="element-211" />

          <p className="text-base mb-6 mt-6" style={{
          color: '#505050'
        }} data-id="element-212">
            "La Colección Más Completa y Accesible de Estudios Paulinos en
            Español"
          </p>

          <div className="rounded-xl p-6 mb-8" style={{
          background: '#EFE7D8',
          border: '1px solid rgba(200,169,106,0.4)',
          boxShadow: '0 2px 14px rgba(60,40,10,0.07)'
        }} data-id="element-213">
            <p className="font-bold text-base leading-relaxed" style={{
            color: '#161616'
          }} data-id="element-214">
              Comprende las <strong data-id="element-215">13 Epístolas Paulinas</strong> con
              Explicaciones Paso a Paso <br data-id="element-216" />
              <span style={{
              color: '#B89555'
            }} data-id="element-217">
                ...¡incluso si nunca pisaste un seminario teológico!
              </span>
            </p>
          </div>

          {/* ─── PRICE + URGENCY BLOCK ─── */}
          <div className="rounded-2xl overflow-hidden" style={{
          border: '2px solid rgba(200,169,106,0.45)',
          boxShadow: '0 6px 32px rgba(60,40,10,0.10)'
        }} data-id="element-218">
            <div className="px-6 pt-7 pb-6" style={{
            background: '#F6F1E7'
          }} data-id="element-219">
              <div className="mb-5" data-id="element-220">
                <img src="https://cdn.magicpatterns.com/uploads/ePA7h5Yx482jbjEg8Guxd6/Capa-Cartas-de-Paulo.webp" alt="Las Cartas de Pablo — Colección Completa" className="w-full h-auto block rounded-xl" data-id="element-221" />
              </div>

              <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{
              color: '#7A7A7A'
            }} data-id="element-222">
                Precio de Oferta:
              </p>
              <div className="mb-1" data-id="element-223">
                <span className="text-xl font-bold" style={{
                color: '#8A8A8A',
                textDecoration: 'line-through'
              }} data-id="element-224">
                  <PriceDisplay type="compare" data-id="element-225" />
                </span>
              </div>
              <div className="text-5xl font-black mb-1 text-gold-gradient" style={{
              fontFamily: 'Merriweather, serif'
            }} data-id="element-226">
                <PriceDisplay type="current" data-id="element-227" />
              </div>
              <p className="text-xs mb-6" style={{
              color: '#505050'
            }} data-id="element-228">
                Pago único · Acceso de por vida
              </p>

              <a href={cartLink} className="block mb-3" onClick={fireAddToCart} data-id="element-229">
                <button className="btn-sacred w-full text-lg py-4 font-serif tracking-wide rounded-xl" data-id="element-230">
                  QUIERO ACCESO INMEDIATO »
                </button>
              </a>

              <p className="text-sm font-bold mb-0.5" style={{
              color: '#2C2C2C'
            }} data-id="element-231">
                Acceso Inmediato a 13 Epístolas + 7 Bonos
              </p>
              <p className="text-xs mb-4" style={{
              color: '#7A7A7A'
            }} data-id="element-232">
                Pago único. Sin cargos mensuales.
              </p>
              <div className="flex items-center justify-center space-x-2 text-xs" style={{
              color: '#7A7A7A'
            }} data-id="element-233">
                <Lock className="w-3 h-3" data-id="element-234" />
                <span data-id="element-235">Pago 100% Seguro</span>
              </div>
            </div>

            <div className="px-6 py-6" style={{
            background: '#EFE7D8',
            borderTop: '1px solid rgba(200,169,106,0.3)'
          }} data-id="element-236">
              <p className="text-lg font-serif font-bold mb-1.5" style={{
              color: '#161616'
            }} data-id="element-237">
                OFERTA{' '}
                <span style={{
                textDecoration: 'underline',
                textDecorationColor: '#C8A96A',
                textDecorationThickness: '2px',
                textUnderlineOffset: '4px'
              }} data-id="element-238">
                  SOLO POR HOY
                </span>{' '}
                !!!
              </p>
              <p className="text-sm mb-0.5" style={{
              color: '#2C2C2C'
            }} data-id="element-239">
                Reserva válida por <strong data-id="element-240">15 minutos.</strong>
              </p>
              <p className="text-sm mb-5" style={{
              color: '#505050'
            }} data-id="element-241">
                Si no accedés, tu descuento pasa a la siguiente persona.
              </p>
              <div className="flex justify-center" data-id="element-242">
                <CountdownTimer data-id="element-243" />
              </div>
            </div>
          </div>
        </div>

        {/* Guarantee note */}
        <div className="flex items-center justify-center gap-2 mb-8 text-sm" style={{
        color: '#505050'
      }} data-id="element-244">
          <ShieldCheck className="w-4 h-4 flex-shrink-0" style={{
          color: '#C8A96A'
        }} data-id="element-245" />
          <span data-id="element-246">
            Garantía de devolución total — sin preguntas, sin letra pequeña
          </span>
        </div>

        {/* Why 10x Better */}
        <div className="rounded-2xl p-5 md:p-10" style={{
        background: '#F6F1E7',
        border: '1px solid rgba(26,107,58,0.2)',
        borderTop: '3px solid rgba(26,107,58,0.5)',
        boxShadow: '0 2px 16px rgba(60,40,10,0.06)'
      }} data-id="element-247">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-center mb-7" style={{
          color: '#161616'
        }} data-id="element-248">
            ¿Qué Lo Hace <em data-id="element-249">10x Mejor</em> Que Cualquier Otro Recurso?
          </h3>
          <div className="space-y-6" data-id="element-250">
            {[{
            title: 'Claridad Total',
            body: <>
                    Explicaciones <strong data-id="element-251">versículo por versículo</strong> en
                    lenguaje simple. Es como tener un{' '}
                    <span style={{
                textDecoration: 'underline',
                textDecorationColor: '#C8A96A',
                textDecorationThickness: '1.5px',
                textUnderlineOffset: '3px'
              }} data-id="element-252">
                      teólogo personal guiándote
                    </span>{' '}
                    capítulo por capítulo.{' '}
                    <em data-id="element-253">Sin tecnicismos. Sin confusión.</em>
                  </>
          }, {
            title: 'Contexto que Transforma',
            body: <>
                    Cada epístola incluye{' '}
                    <strong data-id="element-254">trasfondo histórico y cultural completo</strong>.
                    Sabrás EXACTAMENTE por qué Pablo escribió lo que escribió —{' '}
                    <span style={{
                textDecoration: 'underline',
                textDecorationColor: '#C8A96A',
                textDecorationThickness: '1.5px',
                textUnderlineOffset: '3px'
              }} data-id="element-255">
                      y qué significa para ti HOY.
                    </span>
                  </>
          }, {
            title: 'Las 13 Epístolas Completas',
            body: <>
                    De Romanos a Filemón.{' '}
                    <strong data-id="element-256">Ninguna otra colección en español</strong> cubre las
                    13 cartas con este nivel de detalle y aplicación práctica.{' '}
                    <em data-id="element-257">Todo en un solo paquete.</em>
                  </>
          }].map((item, i) => <div key={i} className="flex" data-id="element-258">
                <div className="flex-shrink-0" data-id="element-259">
                  <div className="flex items-center justify-center h-9 w-9 rounded-lg" style={{
                background: 'rgba(26,107,58,0.1)',
                border: '1px solid rgba(26,107,58,0.25)'
              }} data-id="element-260">
                    <Check className="h-4 w-4" style={{
                  color: '#1A6B3A'
                }} data-id="element-261" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-262">
                  <h4 className="text-base font-bold mb-1" style={{
                color: '#161616'
              }} data-id="element-263">
                    {item.title}
                  </h4>
                  <p className="text-sm leading-relaxed" style={{
                color: '#2C2C2C'
              }} data-id="element-264">
                    {item.body}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}